import ToolsResponseUI from './ToolsResponseUI';

const ToolResponseApprovalUI = ({
  currentToolResults,
  setCurrentToolResults,
}) => {
  if (!currentToolResults) {
    return null;
  }

  const unApprovedToolResponses = (currentToolResults || []).filter(
    (tool_response) => !tool_response.approved,
  );
  // eslint-disable-next-line
  if (unApprovedToolResponses.length == 0) {
    return null;
  }
  const handleToolResponseApproval = (tool_call_id) => {
    setCurrentToolResults((tool_responses) =>
      tool_responses.map((tool_response) => {
        return tool_call_id === tool_response.tool_call_id
          ? { ...tool_response, approved: true }
          : tool_response;
      }),
    );
  };

  return (
    <>
      {unApprovedToolResponses.length > 0 && (
        <div className="tool-requests flex flex-col items-center justify-center space-y-6">
          {unApprovedToolResponses.map((toolResponse) => {
            return (
              <div key={toolResponse.tool_call_id} className="w-full ">
                {/* Render Function Name */}
                <ToolsResponseUI tool={toolResponse} />

                {/* add below and test for that but call one of the above functions by writing inprompt. e..g write get my lalst 5 issues to test it */}
                <div className="flex items-center justify-end gap-2 p-6 pt-0 text-white">
                  <button
                    className="transform rounded-lg border border-zinc-700 bg-zinc-800 px-4 py-1 text-xs transition-transform duration-200 ease-in-out hover:scale-105"
                    onClick={() =>
                      handleToolResponseApproval(toolResponse.tool_call_id)
                    }
                  >
                    AI Response
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default ToolResponseApprovalUI;
